export const convert2dollars = (amount) =>
  amount
    ? Number(amount).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })
    : "N/A";
